export default __webpack_public_path__ + "static/media/Mara 9781408327951.2a9f5af0.jpg";